import React from "react";
import { Modal, Button } from "antd";
import PropTypes from "prop-types";
import { isMobile } from "react-device-detect";

const CustomModal = ({ handleClose, width, handleSubmit, styles, buttonText = "Хадгалах", visible, ...props }) => {
  return (
    <Modal
      centered
      forceRender
      onCancel={() => handleClose()}
      footer={
        handleSubmit
          ? [
              <Button type="primary" onClick={() => handleSubmit()}>
                {buttonText}
              </Button>,
            ]
          : null
      }
      width={isMobile ? "100%" : width ? width : "70%"}
      bodyStyle={{
        padding: isMobile ? "5px" : "40px",
        maxHeight: "100vh",
        overflowY: "auto",
        ...styles,
      }}
      open={visible}
      {...props}
    >
      {props.children}
    </Modal>
  );
};

CustomModal.propTypes = {
  handleClose: PropTypes.func,
  visible: PropTypes.bool,
};

export default CustomModal;
